// @flow
import waitForAnalytics from './wait'

export default function track(event: string, props: {}, options?: {}, callback?: () => void) {
  waitForAnalytics(() => window.analytics.track(`[BEHAVIOR] ${event}`, props, options, callback))
}
